import "./AlertSign.css";

export default function AlertSign() {
  return <img className="alert" alt="" style={{pointerEvents:"none"}}/>;
}
